import React from 'react';
import IconBase from './Icon-base';
export default class EraseNotes extends React.Component {
    render() {
        return (
            <IconBase width="37" height="31" viewBox="0 0 37 31" {...this.props}>
                <desc>Created using Figma</desc>
                <g id="Canvas" transform="translate(-49 235)">
                    <g id="Group 4">
                        <g id="Rectangle_en">
                            <mask id="mask0_outline_ins_en">
                                <use
                                    xlinkHref="#path0_fill_en"
                                    fill="white"
                                    transform="matrix(0.702247 0.711934 -0.702247 0.711934 78.9298 -235)"
                                />
                            </mask>
                            <g mask="url(#mask0_outline_ins_en)">
                                <use
                                    xlinkHref="#path1_stroke_2x_en"
                                    transform="matrix(0.702247 0.711934 -0.702247 0.711934 78.9298 -235)"
                                    fill="#4F5056"
                                />
                            </g>
                        </g>
                        <g id="Line 3.2_en">
                            <use
                                xlinkHref="#path2_stroke_en"
                                transform="translate(54.8387 -222.6)"
                                fill="#4F5056"
                            />
                        </g>
                        <g id="Line 3.3_en">
                            <use
                                xlinkHref="#path3_stroke_en"
                                transform="translate(54.8387 -217)"
                                fill="#4F5056"
                            />
                        </g>
                        <g id="Rectangle_en">
                            <use
                                xlinkHref="#path4_stroke_en"
                                transform="translate(50 -229)"
                                fill="#4F5056"
                            />
                        </g>
                        <g id="Vector 2_en">
                            <use
                                xlinkHref="#path5_stroke_en"
                                transform="translate(75.1429 -217.897)"
                                fill="#4F5056"
                            />
                        </g>
                        <g id="Rectangle 2_en">
                            <use
                                xlinkHref="#path6_fill_en"
                                transform="matrix(0.707107 -0.707107 0.707107 0.707107 71.8275 -226.549)"
                                fill="#4F5056"
                            />
                        </g>
                    </g>
                </g>
                <defs>
                    <path
                        id="path0_fill_en"
                        d="M 0 0L 9.74722 0L 9.74722 13.988C 9.74722 15.6449 8.40407 16.988 6.74722 16.988L 3 16.988C 1.34315 16.988 0 15.6449 0 13.988L 0 0Z"
                    />
                    <path
                        id="path1_stroke_2x_en"
                        d="M 0 0L 0 -1L -1 -1L -1 0L 0 0ZM 9.74722 0L 10.7472 0L 10.7472 -1L 9.74722 -1L 9.74722 0ZM 0 1L 9.74722 1L 9.74722 -1L 0 -1L 0 1ZM 8.74722 0L 8.74722 13.988L 10.7472 13.988L 10.7472 0L 8.74722 0ZM 6.74722 15.988L 3 15.988L 3 17.988L 6.74722 17.988L 6.74722 15.988ZM 1 13.988L 1 0L -1 0L -1 13.988L 1 13.988ZM 3 15.988C 1.89543 15.988 1 15.0926 1 13.988L -1 13.988C -1 16.1972 0.790861 17.988 3 17.988L 3 15.988ZM 8.74722 13.988C 8.74722 15.0926 7.85179 15.988 6.74722 15.988L 6.74722 17.988C 8.95636 17.988 10.7472 16.1972 10.7472 13.988L 8.74722 13.988Z"
                    />
                    <path id="path2_stroke_en" d="M 0 0L 10 0L 10 -1L 0 -1L 0 0Z" />
                    <path id="path3_stroke_en" d="M 0 0L 14 0L 14 -1L 0 -1L 0 0Z" />
                    <path
                        id="path4_stroke_en"
                        d="M 8.03571 17.7778L 8.44197 17.4863C 8.34805 17.3554 8.19682 17.2778 8.03571 17.2778L 8.03571 17.7778ZM 12.5 24L 12.0937 24.2915L 12.5 24.8577L 12.9063 24.2915L 12.5 24ZM 16.9643 17.7778L 16.9643 17.2778C 16.8032 17.2778 16.6519 17.3554 16.558 17.4863L 16.9643 17.7778ZM 0.5 14.7778L 0.5 3L -0.5 3L -0.5 14.7778L 0.5 14.7778ZM 8.03571 17.2778L 3 17.2778L 3 18.2778L 8.03571 18.2778L 8.03571 17.2778ZM 12.9063 23.7085L 8.44197 17.4863L 7.62946 18.0693L 12.0937 24.2915L 12.9063 23.7085ZM 22 17.2778L 16.9643 17.2778L 16.9643 18.2778L 22 18.2778L 22 17.2778ZM 16.558 17.4863L 12.0937 23.7085L 12.9063 24.2915L 17.3705 18.0693L 16.558 17.4863ZM 3 0.5L 20 0.5L 20 -0.5L 3 -0.5L 3 0.5ZM 24.5 13L 24.5 14.7778L 25.5 14.7778L 25.5 13L 24.5 13ZM -0.5 14.7778C -0.5 16.7108 1.067 18.2778 3 18.2778L 3 17.2778C 1.61929 17.2778 0.5 16.1585 0.5 14.7778L -0.5 14.7778ZM 22 18.2778C 23.933 18.2778 25.5 16.7108 25.5 14.7778L 24.5 14.7778C 24.5 16.1585 23.3807 17.2778 22 17.2778L 22 18.2778ZM 0.5 3C 0.5 1.61929 1.61929 0.5 3 0.5L 3 -0.5C 1.067 -0.5 -0.5 1.067 -0.5 3L 0.5 3Z"
                    />
                    <path
                        id="path5_stroke_en"
                        d="M 0 -0.5C -0.276142 -0.5 -0.5 -0.276142 -0.5 0C -0.5 0.276142 -0.276142 0.5 0 0.5L 0 -0.5ZM 9 0.5C 9.27614 0.5 9.5 0.276142 9.5 0C 9.5 -0.276142 9.27614 -0.5 9 -0.5L 9 0.5ZM 0 0.5L 9 0.5L 9 -0.5L 0 -0.5L 0 0.5Z"
                    />
                    <path
                        id="path6_fill_en"
                        d="M 0 0L 10.1261 0L 10.1261 7.97641L 0 7.97641L 0 0Z"
                    />
                </defs>
            </IconBase>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/DocumentViewer/src/SVGIcons/EraseNotes.js